
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/sale",
      function () {
        return require("private-next-pages/products/sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/sale"])
      });
    }
  